import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_PAT_BOOKING_DETAILS,
  GET_PAT_DASHBOARD_DETAILS,
  GET_PAT_INSTALL_DETAILS,
} from "../../Store/Type";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;

export const GetPatDashboardDetails = async (
  dispatch,
  setSpinning,
  refCode
) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)

    const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/totalcount`,
      {
        code: refCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_PAT_DASHBOARD_DETAILS, payload: response.data });

    console.log(response.data, "pat dashboard response");
  } catch (err) {
    console.log(err, "error fetching dashboard response");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetPatInstallDetails = async (dispatch, setSpinning, refCode) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)

    const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/totalInstall`,
      {
        code: refCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_PAT_INSTALL_DETAILS, payload: response.data });

    console.log(response.data, "install response");
  } catch (err) {
    console.log(err, "error fetching install response");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetPatBookingDetails = async (dispatch, setSpinning, refCode) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)

    const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/firstBooking`,
      {
        code: refCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_PAT_BOOKING_DETAILS, payload: response.data });

  } catch (err) {
    console.log(err, "error fetching install response");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const handlePatInstallDetailsSearch = async (e, dispatch,refCode) => {
  try {
    if (e.target.value) {
      const searchTerm = e.target.value;
      console.log(searchTerm, "search term");
      // const response =
      //   searchTerm.trim().length === 0
      //     ? await axios.get(`${apiUrl}/searchbookingdetails/$`)
      //     : await axios.get(`${apiUrl}/searchbookingdetails/${searchTerm}`);
      const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/searchRefferalTotalInstalls`,
      {
        code: refCode,
        letters: searchTerm
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

      dispatch({ type: GET_PAT_INSTALL_DETAILS, payload: response.data });
      return response.data[0];
    } else {
      GetPatInstallDetails(dispatch, undefined, 0);
    }
  } catch (error) {
    // handleError(error);
    console.log(error, "error searching data");
    return null;
  }
};

export const handlePatBookingDetailsSearch = async (e, dispatch,refCode) => {
  try {
    if (e.target.value) {
      const searchTerm = e.target.value;
      console.log(searchTerm, "search term");
      // const response =
      //   searchTerm.trim().length === 0
      //     ? await axios.get(`${apiUrl}/searchbookingdetails/$`)
      //     : await axios.get(`${apiUrl}/searchbookingdetails/${searchTerm}`);
      const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/searchReferralfirstBooking`,
      {
        code: refCode,
        letters: searchTerm
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

      dispatch({ type: GET_PAT_BOOKING_DETAILS, payload: response.data });
      return response.data[0];
    } else {
      GetPatBookingDetails(dispatch, undefined, 0);
    }
  } catch (error) {
    // handleError(error);
    console.log(error, "error searching data");
    return null;
  }
};

export const GetPatInstallDetailsByDate = async (
  dispatch,
  startDate,
  endDate,
  refCode
) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)

    const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/refferalByDateTotalInstalls`,
      {
        from_date: startDate,
        to_date: endDate,
        code: refCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_PAT_INSTALL_DETAILS, payload: response.data });

    console.log(response.data, "date response");
  } catch (err) {
    console.log(err, "date error");
  }
};

export const GetPatBookingDetailsByDate = async (
  dispatch,
  startDate,
  endDate,
  refCode
) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)

    const response = await axios.post(
      `${apiUrl}/partnerReferral/dashboard/refferalByDateFirstBookings`,
      {
        from_date: startDate,
        to_date: endDate,
        code: refCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_PAT_BOOKING_DETAILS, payload: response.data });

    console.log(response.data, "date response");
  } catch (err) {
    console.log(err, "date error");
  }
};